import { useEffect } from 'react';
import { setLocaleWeekCfgOfMoment } from '@gp/utils/common';

export default function useDPSReportMomentLocale(task?: () => void) {
  useEffect(() => {
    // 临时设置星期一作为一周的开始日期
    const revert = setLocaleWeekCfgOfMoment({ dow: 1, doy: 4 });

    task?.();

    return () => {
      // 恢复一周的开始日期（恢复到本次临时设置之前的配置）
      revert();
    };
  }, []);
}
